module.exports = __webpack_public_path__ + "6e6d9c6140a2fd0229308b678cb8730b.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/table/tablewidgetexample.png
// module id = 932
// module chunks = 7